export default __webpack_public_path__ + "aee31b67aa94e9aa7555d24c7186de6c.svg";